/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Col_DateInputs */



/**
* | output |
* | --- |
* | "Date" |
*
* @param {Tournaments_Col_DateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_col_date = /** @type {((inputs?: Tournaments_Col_DateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Col_DateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Date")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fecha")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Data")
	if (locale === "it") return /** @type {LocalizedString} */ ("Data")
	return /** @type {LocalizedString} */ ("Date")
});